<script>
import { MapGender, MapRoles, MapAgentAuth } from "@/common/util";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";

export default {
  data() {
    return {
      formInline: {
        organizationId: "",
        organizationName: "",
        status: "",
        county: "",
        city: "",
        province: ""
      },
      tableData: [],
      addingUser: false,
      resetPassword: false,
      deleteUser: false,
      stopUser: false,
      checkBoxSelect: true,
      buttonArray: [
        {
          text: "重置密码",
          key: "reset"
        },
        {
          text: "停用",
          key: "stop"
        },
        {
          text: "删除",
          key: "delete"
        }
      ],
      textInputArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId"
        // },
        {
          label: "姓名",
          keyName: "name"
        },
        {
          label: "手机号",
          keyName: "phone"
        }
      ],
      resetPasswordArray: [
        {
          label: "手机号",
          keyName: "phone",
          type: "text",
          isDisable: true
        },
        {
          label: "本账户密码",
          keyName: "password",
          type: "password",
          placeholder: "请输入您的登录密码进行验证。"
        }
        // {
        //   label: "",
        //   keyName: "alert",
        //   type: "alert",
        //   alertContent: "系统将自动生成密码并发送到用户的手机"
        // }
      ],
      resetPasswordAlert: "系统将自动生成密码并发送到用户的手机",
      formInputArray: [
        // {
        //   label: "工号",
        //   keyName: "staffId",
        //   type: "text"
        // },
        {
          label: "姓名",
          keyName: "name",
          type: "text"
        },
        {
          label: "性别",
          keyName: "gender",
          type: "radio",
          children: [
            {
              label: "男",
              keyName: "MALE"
            },
            {
              label: "女",
              keyName: "FEMALE"
            }
          ]
        },
        {
          label: "联系电话",
          keyName: "phone",
          type: "text"
        },
        {
          label: "权限",
          keyName: "auths",
          type: "checkbox",
          children: [
            {
              label: "开单",
              keyName: "ROLE_SALESMAN",
              select: true
            },
            {
              label: "数据统计",
              keyName: "ROLE_DATA_MONITOR",
              select: true
            }
          ]
        },
        {
          label: "角色",
          keyName: "role",
          type: "select",
          children: [
            {
              label: "医生",
              keyName: "ROLE_DOCTOR"
            },
            {
              label: "视觉训练师",
              keyName: "ROLE_AGENT_OPTOMETRIST"
            },
            {
              label: "代理商财务",
              keyName: "ROLE_AGENT_FINANCIAL"
            },
            {
              label: "主管",
              keyName: "ROLE_STATION_MANAGER"
            }
          ]
        }
      ],
      searchFormData: {
        staffId: "",
        name: "",
        phone: "",
        role: ""
      },
      totalElements: 0
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {};
      for (let key in this.searchFormData) {
        if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      let data = await this.$http.getAgentAcountList(params);
      if (data && data.content) {
        let newTableData = [];
        data.content.forEach(item => {
          newTableData.push({
            createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
            gender: MapGender(item.gender),
            name: item.name,
            role: MapRoles(item.roles[0]),
            stationName:
              item.stationNumber > 0
                ? `${item.stationName}等${item.stationNumber}家`
                : "",
            staffId: item.staffId,
            phone: item.phone,
            id: item.userId,
            auths:
              item.auths && item.auths.length > 0
                ? item.auths.map(o => MapAgentAuth(o))
                : []
          });
        });
        this.tableData = newTableData;
        this.totalElements = data.totalElements;
      }
    },
    onClick(row) {
      this.$router.push({
        path: `${this.$route.path}/agencyDetail/${row.id}`
      });
    },
    onSearch(data) {
      this.searchFormData = data;
      this.loadData();
    },
    async onUpdateAccount(formdata, type, row) {
      if (type === "resetAccount") {
        const pwd = formdata.password;
        let result = await this.$http.checkAdminPwd(pwd);
        if (result == "success") {
          const updateData = {
            userId: row.id,
            resetPassword: true
          };
          let result = await this.$http.updateAgentAccountInfo(
            type,
            updateData
          );
          if (result) {
            this.$message.success("重置成功");
            this.resetPassword = false;
          }
        } else {
          this.$message.warning("密码错误，请重新输入密码");
        }
      } else if (type === "stopAccount") {
        const updateData = {
          userId: row.id,
          enabled: false
        };
        let result = await this.$http.updateAgentAccountInfo(type, updateData);
      } else if (type === "deleteAccount") {
        let result = await this.$http.updateAgentAccountInfo(type, row.id);
      } else if (type === "addAccount") {
        const updateData = cloneDeep(formdata);
        let result = await this.$http.updateAgentAccountInfo(type, updateData);
      }
      this.loadData();
      this.defaultValue = {};
    },
    onOperationClick(row, key) {
      this.defaultValue = row;
      switch (key) {
        case "reset":
          this.resetPassword = true;
          break;
        case "stop":
          this.stopUser = true;
          break;
        case "delete":
          this.deleteUser = true;
          break;
      }
    },
    onClickCancel(key, afterSubmit) {
      this.defaultValue = {};
      switch (key) {
        case "resetAccount":
          if (afterSubmit !== "afterSubmit") {
            this.resetPassword = false;
          }
          // this.resetPassword = false;
          break;
        case "stopAccount":
          this.stopUser = false;
          break;
        case "deleteAccount":
          this.deleteUser = false;
          break;
      }
    }
  }
};
</script>
<template>
  <div class="agencyAccountIndex">
    <DialogForm
      v-if="addingUser"
      formTitle="添加账号"
      :formInputArray="formInputArray"
      @close="addingUser = false"
      @submitForm="onUpdateAccount"
      keyOperation="addAccount"
    />
    <DialogForm
      v-if="resetPassword"
      formTitle="重置密码"
      :defaultValue="defaultValue"
      :formInputArray="resetPasswordArray"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="resetAccount"
      :alertItem="resetPasswordAlert"
    />
    <DialogForm
      v-if="stopUser"
      :defaultValue="defaultValue"
      formTitle="请确认停用账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="stopAccount"
      confirmButton="确认"
    />
    <DialogForm
      v-if="deleteUser"
      :defaultValue="defaultValue"
      formTitle="请确认删除账号"
      @close="onClickCancel"
      @submitForm="onUpdateAccount"
      keyOperation="deleteAccount"
      confirmButton="确认"
    />
    <searchForm class="searchForm" showSearch @onSearch="onSearch" :textInputArray="textInputArray" />
    <elementButton class="addAccountBtn" @click="addingUser = true">添加账号</elementButton>

    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      @row-click="onClick"
      class="AgencyAccountTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="createdAt" align="left" label="创建时间" width="110"></el-table-column>
      <el-table-column prop="name" align="left" label="姓名" min-width="80"></el-table-column>
      <el-table-column prop="gender" align="left" label="性别" width="55"></el-table-column>
      <el-table-column prop="phone" align="left" label="联系电话" width="120"></el-table-column>
      <el-table-column prop="auth" align="left" label="权限"  width="100">
        <template slot-scope="scope">
          <el-checkbox
            v-for="item in scope.row.auths"
            :key="scope.row.id + item"
            v-model="checkBoxSelect"
            class="checkBoxLabel"
            disabled
          >{{item}}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column prop="role" align="left" label="角色" min-width="80"></el-table-column>
      <el-table-column prop="stationName" align="left" label="服务机构" min-width="100"></el-table-column>
      <el-table-column prop="operation" align="left" label="操作" width="200">
        <template slot-scope="scope">
          <textButtonGroup
            :buttonArray="buttonArray"
            :rowData="scope.row"
            @onOperationClick="onOperationClick"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.agencyAccountIndex {
  .searchForm {
    max-width: 90%;
    height: 70px;
    margin-left: 1%;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-top: 15px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .AgencyAccountTable {
    margin: 20px 2%;
    border: 1px;
    width: 96%;

    .checkBoxLabel {
      color: #303133;

      .el-checkbox__input.is-disabled + span.el-checkbox__label {
        color: #303133;
      }
    }

    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
  }

  .addAccountBtn {
    width: 83px;
    height: 35px;
    margin-top: 5px;
    margin-bottom: 10px;
    border-radius: 3px;
    float: left;
    margin-left: 2%;
    padding: 3px;
    background-color: #00c1de;
    border-color: #00c1de !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/agencyAccounts/index.vue